export interface EventReferentModel {
  id: number;
  name: string;
  email: string | null;
  phone: string | null;
  role: { id: number; key: string; name: string } | null;
}

export interface EventApplicantModel {
  id: number;
  name: string;
  email: string | null;
  phone: string | null;
}

export interface EventFileModel {
  id: number;
  name: string;
  observacion: string | null;
  url: string | null;
  user: { id: number; name: string } | null;
}

export interface EventObservationModel {
  id: number;
  observation: string;
  user: { id: number; name: string } | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface EventTransferReservationModel {
  id: number;
  status: { id: number; name: string };
}

export interface EventModel {
  id: number;
  name: string;
  description: string | null;
  fromDate: string | null;
  toDate: string | null;
  isActive: boolean;
  businessClient: { id: number; name: string };
  referents: EventReferentModel[];
  applicants: EventApplicantModel[];
  observations: EventObservationModel[];
  signages: EventFileModel[];
  budgets: EventFileModel[];
  transferReservations: EventTransferReservationModel[];
  createdAt: string;
  updatedAt: string;
}

export interface EventResourceDto {
  id: number;
  name: string;
  description: string | null;
  from_date: string | null;
  to_date: string | null;
  is_active: boolean;
  business_client: { id: number; name: string };
  applicants?: EventApplicantModel[];
  referents: {
    id: number;
    name: string;
    email: string | null;
    phone: string | null;
    role: { id: number; key: string; name: string } | null;
  }[];
  observations: {
    id: number;
    observation: string;
    user: { id: number; name: string } | null;
    created_at: string | null;
    updated_at: string | null;
  }[];
  signages: {
    id: number;
    name: string;
    observacion: string | null;
    url: string | null;
    user: { id: number; name: string } | null;
  }[];
  budgets: {
    id: number;
    name: string;
    observacion: string | null;
    url: string | null;
    user: { id: number; name: string } | null;
  }[];
  transfer_reservations: {
    id: number;
    status: { id: number; name: string };
  }[];
  created_at: string;
  updated_at: string;
}

export const eventBuilder = {
  fromBackend: (dto: EventResourceDto): EventModel => ({
    id: dto.id,
    name: dto.name,
    description: dto.description,
    fromDate: dto.from_date,
    toDate: dto.to_date,
    isActive: dto.is_active,
    businessClient: dto.business_client,
    referents: dto.referents ?? [],
    applicants: dto.applicants ?? [],
    observations: (dto.observations ?? []).map((observation) => ({
      id: observation.id,
      observation: observation.observation,
      user: observation.user,
      createdAt: observation.created_at,
      updatedAt: observation.updated_at
    })),
    signages: dto.signages ?? [],
    budgets: dto.budgets ?? [],
    transferReservations: dto.transfer_reservations ?? [],
    createdAt: dto.created_at,
    updatedAt: dto.updated_at
  })
};
